import { Subject } from 'rxjs';

export class AccordionItem {
  isExpanded: boolean = false;
  changed: Subject<boolean> = new Subject();

  private uuid: string;

  constructor() {
    this.uuid = crypto.randomUUID();
  }

  get id(): string {
    return this.uuid;
  }
}
